import { Injectable, inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoginModalComponent } from '../modals/login-modal/login-modal.component';
import { RegisterModalComponent } from '../modals/register-modal/register-modal.component';

@Injectable({
  providedIn: 'root',
})
export class AuthModalService {
  private readonly modalService = inject(NgbModal);

  openLoginModal(returnUrl: string = ''): void {
    const modalRef = this.modalService.open(LoginModalComponent, {
      ariaLabelledBy: 'modal-basic-title',
      backdrop: 'static',
      keyboard: false,
    });
    modalRef.componentInstance.returnUrl = returnUrl;
  }

  openRegisterModal(returnUrl: string = ''): void {
    const modalRef = this.modalService.open(RegisterModalComponent, {
      ariaLabelledBy: 'modal-basic-title',
      backdrop: 'static',
      keyboard: false,
    });
    modalRef.componentInstance.returnUrl = returnUrl;
  }

  closeLoginModal(): void {
    // NgBootstrap handles modal closing automatically
    this.modalService.dismissAll();
  }

  closeRegisterModal(): void {
    // NgBootstrap handles modal closing automatically
    this.modalService.dismissAll();
  }
}
